import '../assets/NcDashboardWidget-BEYk4O95.css';
import { N as NcAvatar } from "./NcAvatar-Cg9PDzho.mjs";
import { N as NcDashboardWidgetItem } from "./NcDashboardWidgetItem-BsHwLKh3.mjs";
import { N as NcEmptyContent } from "./NcEmptyContent-CBWBkBL8.mjs";
import { C as Check } from "./Check-5i4xKnkl.mjs";
import { r as register, j as t33, a as t } from "./_l10n-dinIMiE_.mjs";
import { resolveComponent, createElementBlock, openBlock, createBlock, createCommentVNode, createElementVNode, renderSlot, withCtx, createVNode, Fragment, renderList, mergeProps, toHandlers, toDisplayString } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
register(t33);
const _sfc_main = {
  name: "NcDashboardWidget",
  components: {
    NcAvatar,
    NcDashboardWidgetItem,
    NcEmptyContent,
    Check
  },
  props: {
    /**
     * An array containing the items to show (specific structure must be respected,
     * except if you override item rendering in the default slot).
     */
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    /**
     * If this is set, a "show more" text is displayed on the widget's bottom.
     * It's a link pointing to this URL.
     */
    showMoreUrl: {
      type: String,
      default: ""
    },
    /**
     * The text of show more button.
     *
     * Expected to be in the form "More {itemName} …"
     */
    showMoreLabel: {
      type: String,
      default: t("More items …")
    },
    /**
     * A boolean to put the widget in a loading state.
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * An object containing context menu entries that will be displayed for each item.
     */
    itemMenu: {
      type: Object,
      default: () => {
        return {};
      }
    },
    /**
     * Whether both the items and the empty content message are shown.
     * Usefull for e.g. showing "No mentions" and a list of elements.
     */
    showItemsAndEmptyContent: {
      type: Boolean,
      default: false
    },
    /**
     * The text to show in the empty content area.
     */
    emptyContentMessage: {
      type: String,
      default: ""
    },
    /**
     * The text to show in the half empty content area.
     */
    halfEmptyContentMessage: {
      type: String,
      default: ""
    }
  },
  computed: {
    // forward menu events to my parent
    handlers() {
      const h = {};
      for (const evName in this.itemMenu) {
        h[evName] = (it) => {
          this.$emit(evName, it);
        };
      }
      return h;
    },
    displayedItems() {
      const nbItems = this.showMoreUrl && this.items.length >= this.maxItemNumber ? this.maxItemNumber - 1 : this.maxItemNumber;
      return this.items.slice(0, nbItems);
    },
    showHalfEmptyContentArea() {
      return this.showItemsAndEmptyContent && this.halfEmptyContentString && this.items.length !== 0;
    },
    halfEmptyContentString() {
      return this.halfEmptyContentMessage || this.emptyContentMessage;
    },
    maxItemNumber() {
      return this.showItemsAndEmptyContent ? 5 : 7;
    },
    showMore() {
      return this.showMoreUrl && this.items.length >= this.maxItemNumber;
    }
  }
};
const _hoisted_1 = { class: "dashboard-widget" };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = ["href"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Check = resolveComponent("Check");
  const _component_NcEmptyContent = resolveComponent("NcEmptyContent");
  const _component_NcDashboardWidgetItem = resolveComponent("NcDashboardWidgetItem");
  const _component_NcAvatar = resolveComponent("NcAvatar");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    $options.showHalfEmptyContentArea ? (openBlock(), createBlock(_component_NcEmptyContent, {
      key: 0,
      description: $options.halfEmptyContentString,
      class: "half-screen"
    }, {
      icon: withCtx(() => [
        renderSlot(_ctx.$slots, "halfEmptyContentIcon", {}, () => [
          createVNode(_component_Check)
        ], true)
      ]),
      _: 3
    }, 8, ["description"])) : createCommentVNode("", true),
    createElementVNode("ul", null, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($options.displayedItems, (item) => {
        return openBlock(), createElementBlock("li", {
          key: item.id
        }, [
          renderSlot(_ctx.$slots, "default", { item }, () => [
            createVNode(_component_NcDashboardWidgetItem, mergeProps({ ref_for: true }, item, { "item-menu": $props.itemMenu }, toHandlers($options.handlers)), null, 16, ["item-menu"])
          ], true)
        ]);
      }), 128))
    ]),
    $props.loading ? (openBlock(), createElementBlock("div", _hoisted_2, [
      (openBlock(), createElementBlock(Fragment, null, renderList(7, (i) => {
        return createElementVNode("div", {
          key: i,
          class: "item-list__entry"
        }, [
          createVNode(_component_NcAvatar, {
            class: "item-avatar",
            size: 44
          }),
          _cache[0] || (_cache[0] = createElementVNode("div", { class: "item__details" }, [
            createElementVNode("h3", null, " "),
            createElementVNode("p", { class: "message" }, "   ")
          ], -1))
        ]);
      }), 64))
    ])) : $props.items.length === 0 ? renderSlot(_ctx.$slots, "empty-content", { key: 2 }, () => [
      $props.emptyContentMessage ? (openBlock(), createBlock(_component_NcEmptyContent, {
        key: 0,
        description: $props.emptyContentMessage
      }, {
        icon: withCtx(() => [
          renderSlot(_ctx.$slots, "emptyContentIcon", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["description"])) : createCommentVNode("", true)
    ], true) : $options.showMore ? (openBlock(), createElementBlock("a", {
      key: 3,
      href: $props.showMoreUrl,
      target: "_blank",
      class: "more",
      tabindex: "0"
    }, toDisplayString($props.showMoreLabel), 9, _hoisted_3)) : createCommentVNode("", true)
  ]);
}
const NcDashboardWidget = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-367e73aa"]]);
export {
  NcDashboardWidget as N
};
//# sourceMappingURL=NcDashboardWidget-CC2pZ6GI.mjs.map
